var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullGrid"},[_c('div',{ref:"divMap",attrs:{"id":"divMap"}}),_c('ToolBar',{ref:"ToolBar",attrs:{"Map":_vm.mySelf()}}),_c('FooterInfo',{ref:"FooterInfo",attrs:{"objectsName":_vm.objectsName,"selected":_vm.selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }